import React, { Component } from 'react';
import Spinner from './Spinner';
import { Scrollbars } from 'react-custom-scrollbars';
import Checkbox from './Checkbox';
import Dropdown from './Dropdown';
import ReactDOM from "react-dom";
import {countriesOptions} from '../config/options'; 
import MobileCart from './MobileCart';
import MediaQuery from 'react-responsive';

class Cart extends Component {

    constructor(props){
        super(props);

        this.state={
            promocode: this.props.promoCode,
            client: {
                FirstName: this.props.client.FirstName,
                LastName: this.props.client.LastName,
                Email: this.props.client.Email,
                Code: this.props.client.Code,
                Company: this.props.client.Company,
                Phone: this.props.client.Phone,
                Zip: this.props.client.Zip,
                Country: this.props.client.Country,
                Nationality: this.props.client.Nationality,
                City: this.props.client.City,
                Address: this.props.client.Address,
                Notes: this.props.client.Notes
            }
        }
        
        this.backToSearch = this.backToSearch.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.checkEarlyCheckIn = this.checkEarlyCheckIn.bind(this);
        this.checkLateCheckOut = this.checkLateCheckOut.bind(this);
        this.checkBreakfast = this.checkBreakfast.bind(this);
        this.checkDinner = this.checkDinner.bind(this);
        this.addBrekfast = this.addBrekfast.bind(this);
        this.addDinner = this.addDinner.bind(this);
        this.updatePersons = this.updatePersons.bind(this);
        this.updatePromoCode = this.updatePromoCode.bind(this);
        this.changeGuestFirstName = this.changeGuestFirstName.bind(this);
        this.changeGuestLastName = this.changeGuestLastName.bind(this);
        this.changeGuestNotes = this.changeGuestNotes.bind(this);
        this.recalculatePrice = this.recalculatePrice.bind(this);
        this.editClientFirstName = this.editClientFirstName.bind(this);
        this.editClientLastName = this.editClientLastName.bind(this);
        this.editClientEmail = this.editClientEmail.bind(this);
        this.editClientCode = this.editClientCode.bind(this);
        this.editClientCompany = this.editClientCompany.bind(this);
        this.editClientPhone = this.editClientPhone.bind(this);
        this.editClientZip = this.editClientZip.bind(this);
        this.editClientCountry = this.editClientCountry.bind(this);
        this.editClientNationality = this.editClientNationality.bind(this);
        this.editClientCity = this.editClientCity.bind(this);
        this.editClientAddress = this.editClientAddress.bind(this);
        this.editClientNotes = this.editClientNotes.bind(this);        
    }

    backToSearch(){
        this.props.onBackToSearch();
    }

    deleteItem(item){ 
        const itemToDelete = item.target.attributes.getNamedItem('item').value;
        let reducedCart = this.props.items;
        reducedCart.splice(itemToDelete, 1);
        this.props.onUpdateCart(reducedCart);
    }

    addBrekfast(val, item){
        if(!this.props.items[item].breakfast){
            ReactDOM.findDOMNode(this).getElementsByClassName('breakfastLabel'+item)[0].click();
        }
        let updatedCart = this.props.items;
        updatedCart[item].numbreakfast = val;
        this.props.onUpdateCart(updatedCart);
    }

    addDinner(val, item){
        if(!this.props.items[item].dinner){
            ReactDOM.findDOMNode(this).getElementsByClassName('dinnerLabel'+item)[0].click();
        }
        let updatedCart = this.props.items;
        updatedCart[item].numdinner = val;
        this.props.onUpdateCart(updatedCart);
    }

    checkBreakfast(event){
        const itemToUpdate = event.target.attributes.getNamedItem('item').value;
        let updatedCart = this.props.items;
        if(event.target.checked){
            updatedCart[itemToUpdate].breakfast = 1;
        }else{
            updatedCart[itemToUpdate].breakfast = 0;
        }
        this.props.onUpdateCart(updatedCart);
    }

    checkDinner(event){
        const itemToUpdate = event.target.attributes.getNamedItem('item').value;
        let updatedCart = this.props.items;
        if(event.target.checked){
            updatedCart[itemToUpdate].dinner = 1;
        }else{
            updatedCart[itemToUpdate].dinner = 0;
        }
        this.props.onUpdateCart(updatedCart);
    }

    checkEarlyCheckIn(event){
        const itemToUpdate = event.target.attributes.getNamedItem('item').value;
        let updatedCart = this.props.items;
        if(event.target.checked){
            updatedCart[itemToUpdate].earlyCheckIn = 1;
        }else{
            updatedCart[itemToUpdate].earlyCheckIn = 0;
        }
        this.props.onUpdateCart(updatedCart);   
    }

    checkLateCheckOut(event){
        const itemToUpdate = event.target.attributes.getNamedItem('item').value;
        let updatedCart = this.props.items;
        if(event.target.checked){
            updatedCart[itemToUpdate].lateCheckOut = 1;
        }else{
            updatedCart[itemToUpdate].lateCheckOut = 0;
        }
        this.props.onUpdateCart(updatedCart);
    }

    updatePersons(val, item){
        let updatedCart = this.props.items;
        updatedCart[item].numPersons = val;
        this.props.onUpdateCart(updatedCart);
    }

    changeGuestFirstName(event){
        const itemToUpdate = event.target.attributes.getNamedItem('item').value;
        const guestToUpdate = event.target.attributes.getNamedItem('guest').value;
        let updatedCart = this.props.items;
        if(updatedCart[itemToUpdate].guests !== undefined){
            if(updatedCart[itemToUpdate].guests[guestToUpdate] !== undefined){
                updatedCart[itemToUpdate].guests[guestToUpdate].FirstName = event.target.value;
            }else{
                updatedCart[itemToUpdate].guests[guestToUpdate] = {'FirstName': event.target.value}
            }            
        }else{
            updatedCart[itemToUpdate].guests = [];
            updatedCart[itemToUpdate].guests.push({'FirstName': event.target.value})
        }
        this.props.onUpdateCart(updatedCart);
    }

    changeGuestLastName(event){
        const itemToUpdate = event.target.attributes.getNamedItem('item').value;
        const guestToUpdate = event.target.attributes.getNamedItem('guest').value;
        let updatedCart = this.props.items;
        if(updatedCart[itemToUpdate].guests !== undefined){
            if(updatedCart[itemToUpdate].guests[guestToUpdate] !== undefined){
                updatedCart[itemToUpdate].guests[guestToUpdate].LastName = event.target.value;
            }else{
                updatedCart[itemToUpdate].guests[guestToUpdate] = {'LastName': event.target.value}
            }  
        }else{
            updatedCart[itemToUpdate].guests = [];
            updatedCart[itemToUpdate].guests.push({'LastName': event.target.value})
        }
        this.props.onUpdateCart(updatedCart);
    }

    changeGuestNotes(event){
        const itemToUpdate = event.target.attributes.getNamedItem('item').value;
        let updatedCart = this.props.items;
        updatedCart[itemToUpdate].guestNotes = event.target.value;
    }

    updatePromoCode(event){
        this.setState({promocode: event.target.value});
    }

    recalculatePrice(){ console.log(this.state.promocode);
        let updatedCart = this.props.items;
        for (var i = 0; i < updatedCart.length; i++) {
            updatedCart[i].promocode = this.state.promocode;
        }
        this.props.onUpdateCart(updatedCart);
    }

    editClientFirstName(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                FirstName: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
        
    }

    editClientLastName(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                LastName: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientEmail(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                Email: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientCode(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                Code: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientCompany(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                Company: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientPhone(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                Phone: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientZip(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                Zip: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientCountry(val){
        const v = val
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                Country: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientNationality(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                Nationality: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientCity(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                City: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientAddress(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                Address: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    editClientNotes(event){
        const v = event.target.value
        this.setState(prevState => ({
            client: {
                ...prevState.client,
                Notes: v
            }
        }), 
        ()=>{this.props.onUpdateClient(this.state.client)});
    }

    render(){
        let totalCartAmt = 0; 
        const items = this.props.items.map(
            (itm, i)=>{
                let curent_price = 0;
                if(itm.object.numbeds*1 === 1){
                    if(itm.object.bedsize === 'double' || itm.object.bedsize === 'kingsize'){
                        if(itm.numPersons*1 === 1){
                            curent_price = itm.object.price_1
                        }else{
                            curent_price = itm.object.price;
                        }
                    }else{
                        curent_price = itm.object.price;
                    }
                }else if(itm.object.numbeds*1 === 2){
                    if(itm.numPersons*1 === 1){
                        curent_price = itm.object.price_1
                    }else{
                        curent_price = itm.object.price;
                    }
                }else{
                    if(itm.object.numbeds*1 === itm.numPersons*1){
                        curent_price = itm.object.price;
                    }else{
                        if(itm.numPersons*1 === 1){
                            curent_price = itm.object.price_1;                   
                        }else if(itm.numPersons*1 === 2){
                            curent_price = itm.object.price_2;
                        }else if(itm.numPersons*1 === 3){
                            curent_price = itm.object.price_3;
                        }else{
                            curent_price = itm.object.price;
                        }             
                    }            
                }    
                const additionalPrice = itm.earlyCheckIn*itm.object.earlycheckin + 
                                    itm.lateCheckOut*itm.object.latecheckout +
                                    itm.breakfast*itm.numbreakfast*itm.object.breakfastprice +
                                    itm.dinner*itm.numdinner*itm.object.dinnerprice;
                const numNights  = itm.dateInterval ? Math.round(itm.dateInterval / 86400 / 1000) : 1;
                const total = (curent_price - (itm.promocode ? itm.object.promodiscount : 0) + additionalPrice) * numNights;
                totalCartAmt+=total;

                //guests names
                let guests = [];                
                for(let j=0; j<itm.numPersons; j++){
                    let guestFirstName = '';
                    let guestLastName = '';
                    if(itm.guests !== undefined){
                        if(itm.guests[j] !== undefined){
                            guestFirstName = itm.guests[j].FirstName;
                            guestLastName = itm.guests[j].LastName;
                        }
                    }
                    guests[j] = <div key={i+'-'+j}>
                                <input type="text" defaultValue={guestFirstName} placeholder="First Name" item={i} guest={j} onBlur={this.changeGuestFirstName}/>
                                <input type="text" defaultValue={guestLastName} placeholder="Last Name" item={i} guest={j} onBlur={this.changeGuestLastName}/>
                            </div>
                }
                return( 
                    <div className="vb-order3items" key={i}>
                        <div className="vb-order3items-col1">
                            <div className="vb-order3items-photo"style={{'backgroundImage': 'url("'+itm.object.photos[0]+'")'}}>
                                <p>{itm.object.name}</p>
                                <div className="vd-data">
                                    <span>{itm.dateInterval.start.format("MM/DD/YYYY")} - {itm.dateInterval.end.format("MM/DD/YYYY")}</span>
                                </div>
                            </div>
                            <div className="vb-order3items-conditions">
                                <p>Nights:</p>
                                <span>{itm.dateInterval ? Math.round(itm.dateInterval / 86400 / 1000) : 1}</span>
                            </div>
                            <div className="vb-order3items-conditions">
                                <p>Persons:</p>                                
                                <Spinner value={itm.numPersons} onChange={this.updatePersons} item={i}/>                                
                            </div>
                            {additionalPrice ?
                            <div className="vb-order3items-conditions">
                                <p>Additions:</p>
                                <span>{additionalPrice}kr</span>
                            </div>
                            : ''}
                            {(itm.promocode && itm.object.promodiscount) ? 
                            <div className="vb-order3items-conditions">
                                <p>Discount:</p>
                                <span>{itm.object.promodiscount}kr</span>
                            </div>
                            : ''}
                            <div className="vb-order3items-total">
                                <p>Total:</p>
                                <span>{total}kr</span>
                            </div>
                        </div>
                        <div className="vb-order3items-col2">
                            <button className="vb-order3items-basket" item={i} onClick={this.deleteItem}>
                                <svg  width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path item={i} fillRule="evenodd" clipRule="evenodd" d="M2.03077 11.1855C2.03077 11.1855 2.20952 12 3.12955 12H7.28957C8.20956 12 8.38831 11.1855 8.38831 11.1855L9.20956 3.20002H1.20956L2.03077 11.1855ZM6.80957 4.40004C6.80957 4.1791 6.98863 4.00004 7.20956 4.00004C7.4305 4.00004 7.6096 4.1791 7.6096 4.40004L7.20956 10.4C7.20956 10.621 7.03046 10.8 6.80957 10.8C6.58868 10.8 6.40958 10.6209 6.40958 10.4L6.80957 4.40004ZM4.80957 4.40004C4.80957 4.1791 4.98867 4.00004 5.20956 4.00004C5.4305 4.00004 5.60955 4.1791 5.60955 4.40004V10.4C5.60955 10.621 5.4305 10.8 5.20956 10.8C4.98863 10.8 4.80957 10.6209 4.80957 10.4V4.40004ZM3.20956 4C3.4305 4 3.60955 4.17905 3.60955 4.39999L4.00959 10.4C4.00959 10.6209 3.83049 10.8 3.60955 10.8C3.38866 10.8 3.20956 10.6209 3.20956 10.4L2.80957 4.40004C2.80957 4.1791 2.98867 4 3.20956 4ZM8.96954 1.60063H7.20956V0.800027C7.20956 0.193179 7.0133 0 6.40958 0H4.00954C3.4558 0 3.20956 0.268225 3.20956 0.800027V1.60068H1.44958C1.09585 1.60068 0.80957 1.86917 0.80957 2.20096C0.80957 2.53278 1.09585 2.80128 1.44958 2.80128H8.96954C9.32327 2.80128 9.60955 2.53278 9.60955 2.20096C9.60955 1.86917 9.32327 1.60063 8.96954 1.60063ZM6.40958 1.60063H4.00959L4.00963 0.799982H6.40963V1.60063H6.40958Z" fill="#4A2E22"/>
                                </svg>
                            </button>
                            {(itm.object.breakfastprice || itm.object.dinnerprice || itm.object.earlycheckin || itm.object.latecheckout) ? 
                            <div className="vb-order-open">
                                <h2>Additionals</h2>
                                <div className="vb-additionals-box">
                                    {itm.object.breakfastprice ?
                                    <div className="vb-checkbox">
                                        <Checkbox item={i} checked={itm.breakfast} onChange={this.checkBreakfast} id={'item_breakfast'+i}/>
                                        <p><label className={"breakfastLabel"+i} htmlFor={'item_breakfast'+i}>Breakfast included ({itm.object.breakfastprice}kr)</label></p>
                                        <span className="vb-number-box">
                                            <Spinner value={itm.numbreakfast} onChange={this.addBrekfast} item={i}/>							
                                        </span>
                                    </div>
                                    : ''}

                                    {itm.object.dinnerprice ?
                                    <div className="vb-checkbox">
                                        <Checkbox item={i} checked={itm.dinner} onChange={this.checkDinner} id={'item_dinner'+i}/>
                                        <p><label className={"dinnerLabel"+i} htmlFor={'item_dinner'+i}>Breakfast included ({itm.object.dinnerprice}kr)</label></p>
                                        <span className="vb-number-box">
                                            <Spinner value={itm.numdinner} onChange={this.addDinner} item={i}/>							
                                        </span>
                                    </div>
                                    : ''}

                                    {itm.object.earlycheckin ?
                                    <div className="vb-checkbox">
                                        <Checkbox item={i} checked={itm.earlyCheckIn} onChange={this.checkEarlyCheckIn} id={'item_early_checkin'+i}/>
                                        <p><label htmlFor={'item_early_checkin'+i}>Early check-in (before 11:00 am) ({itm.object.earlycheckin}kr)</label></p>                                        
                                    </div>
                                    : ''}

                                    {itm.object.latecheckout ?
                                    <div className="vb-checkbox">
                                        <Checkbox item={i} checked={itm.lateCheckOut} onChange={this.checkLateCheckOut} id={'item_late_checkout'+i}/>
                                        <p><label htmlFor={'item_late_checkout'+i}>Late check-out (after 2:00 pm) ({itm.object.latecheckout}kr)</label></p>                                        
                                    </div>
                                    : ''}

                                </div>
                            </div>
                            : ''}
                            <div className="vb-guest-name">
                                <h2>Guest{guests.length > 1 ? 's' : ''} name{guests.length > 1 ? 's' : ''}</h2>
                                {guests}
                            </div>

                            <div className="vb-notes">
                                <h2>Notes</h2>
                                <div>
                                    <input type="text" defaultValue={typeof itm.guestNotes !== 'undefined' ? itm.guestNotes : ''} placeholder="Notes" item={i} onChange={this.changeGuestNotes}/>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        )

        return(
            <div>
                <MediaQuery query="(min-width: 600px)">
                    <div className="vb-information-order3items">
                        <div className="vb-leftcol-information">
                            <h2>Information:</h2>

                            <div className="vb-information-order3items-box">
                                <div className="vb-information-order3items-block">
                                    <input type="text" defaultValue={this.state.client.FirstName} placeholder="First Name" onBlur={this.editClientFirstName}/>
                                    {this.state.client.FirstName ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                                <div className="vb-information-order3items-block">
                                    <input type="text" defaultValue={this.state.client.LastName} placeholder="Last Name" onBlur={this.editClientLastName}/>
                                    {this.state.client.LastName ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                            </div>

                            <div className="vb-information-order3items-box">
                                <div className="vb-information-order3items-block">
                                    <input type="email" defaultValue={this.state.client.Email} placeholder="E-mail" onBlur={this.editClientEmail}/>
                                    <button>Send a code</button>
                                </div>
                                <div className="vb-information-order3items-block">
                                    <input type="text" defaultValue={this.state.client.Code} placeholder="Code" onBlur={this.editClientCode}/>
                                    {this.state.client.Code ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                            </div>

                            <div className="vb-information-order3items-box">
                                <div className="vb-information-order3items-block">
                                    <input type="text" defaultValue={this.state.client.Company} placeholder="Company" onBlur={this.editClientCompany}/>
                                    {this.state.client.Company ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                                <div className="vb-information-order3items-block">
                                    <input type="tel" defaultValue={this.state.client.Phone} placeholder="Phone" onBlur={this.editClientPhone}/>
                                    {this.state.client.Phone ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                            </div>

                            <h2>Your location:</h2>

                            <div className="vb-information-order3items-box">
                                <div className="vb-information-order3items-block">
                                    <input type="text" defaultValue={this.state.client.Zip} placeholder="Zip-code" onBlur={this.editClientZip}/>
                                    {this.state.client.Zip ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                                <div className="vb-information-order3items-block">                            
                                    <Dropdown
                                            value={this.state.client.Country} 
                                            options={countriesOptions}                                    
                                            placeholder='Country'
                                            name="country"
                                            className="vb-select-rooms"
                                            onChange={this.editClientCountry}
                                    />                        
                                    {this.state.client.Country ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                            </div>

                            <div className="vb-information-order3items-box">
                                <div className="vb-information-order3items-block">
                                    <input type="text" defaultValue={this.state.client.Nationality} placeholder="Nationality" onBlur={this.editClientNationality}/>
                                    {this.state.client.Nationality ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                                <div className="vb-information-order3items-block">
                                    <input type="text" defaultValue={this.state.client.City} placeholder="City" onBlur={this.editClientCity}/>
                                    {this.state.client.City ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                            </div>

                            <div className="vb-information-order3items-box">
                                <div className="vb-information-order3items-block">
                                    <input type="text" defaultValue={this.state.client.Address} placeholder="Address" onBlur={this.editClientAddress}/>
                                    {this.state.client.Address ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                            </div>

                            <h2>Notes:</h2>

                            <div className="vb-information-order3items-box">
                                <div className="vb-information-order3items-block textarea-block">
                                    <textarea defaultValue={this.state.client.Notes} onBlur={this.editClientNotes}/>
                                    {this.state.client.Notes ? 
                                    <span className="greenCheckBox"></span>
                                    : ''}
                                </div>
                            </div>

                        </div>

                        <div className="vb-content">
                            <h2>Order ({this.props.items.length} item{this.props.items.length > 1 ? 's' : ''})</h2>
                            <Scrollbars style={{ height:494 }}>
                            {items}
                            </Scrollbars>
                            <div className="vb-total-bottom">
                                <div className="vb-tb-leftcol">
                                    <div>
                                        <p>Total:</p>
                                        <span>{totalCartAmt}kr</span>
                                    </div>
                                    <div>
                                        <p>enter discount code</p>
                                        <span>
                                            <input type="text" placeholder="Code" defaultValue={this.state.promocode} onChange={this.updatePromoCode}/>
                                            <input type="submit" value="" onClick={this.recalculatePrice} readOnly/>
                                        </span>
                                    </div>
                                </div>
                                <div className="vb-tb-rightcol">
                                    <div>

                                        <div className="vb-checkbox">
                                            <Checkbox  id="cart-subscribe"/>
                                            <span><label htmlFor="cart-subscribe">Subscribe to newsletters</label></span>                                        
                                        </div>
                                        <div className="vb-checkbox">
                                            <Checkbox id="cart-terms"/>
                                            <span><label htmlFor="cart-terms">Confirm terms and conditions</label></span>
                                        </div>
                                    </div>
                                    <div>
                                        <button className="vb-backtosearch" onClick={this.backToSearch}>back to search</button>
                                        <button className="vb-gotopayment">Go to payment</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                    </div> 
                </MediaQuery>
                <MediaQuery query="(max-width: 599px)">
                    <MobileCart items={this.props.items}
                                promocode={this.state.promocode}
                                client={this.state.client}
                                onBackToSearch={this.backToSearch}
                                onUpdatePromoCode={this.updatePromoCode}
                                onRecalculatePrice={this.recalculatePrice}
                                onDeleteItem={this.deleteItem}
                                onEditClientFirstName={this.editClientFirstName}
                                onEditClientLastName={this.editClientLastName}
                                onEditClientEmail={this.editClientEmail}
                                onEditClientCode={this.editClientCode}
                                onEditClientCompany={this.editClientCompany}
                                onEditClientPhone={this.editClientPhone}
                                onEditClientZip={this.editClientZip}
                                onEditClientCountry={this.editClientCountry}
                                onEditClientNationality={this.editClientNationality}
                                onEditClientCity={this.editClientCity}
                                onEditClientAddress={this.editClientAddress}
                                onEditClientNotes={this.editClientNotes}
                                onUpdatePersons={this.updatePersons}
                                onChangeGuestFirstName={this.changeGuestFirstName}
                                onChangeGuestLastName={this.changeGuestLastName}
                                onChangeGuestNotes={this.changeGuestNotes}
                                onCheckBreakfast={this.checkBreakfast}
                                onAddBrekfast={this.addBrekfast}
                                onCheckDinner={this.checkDinner}
                                onAddDinner={this.addDinner}
                                onCheckEarlyCheckIn={this.checkEarlyCheckIn}
                                onCheckLateCheckOut={this.checkLateCheckOut}
                    />
                </MediaQuery>  
            </div>         
        )
    }
}

export default Cart;